// extracted by mini-css-extract-plugin
module.exports = {"whole-home":"WholeHome_whole-home__4tPjT"};